// 支持与服务
import request from '@/utils/request'

// 创建工单
export function queryAllTicketCategory() {
    return request.post('/ticketCategory/queryAllTicketCategory')
}
export function queryQuestionTypeByTicketCategoryId(id) {
    return request.post('/questionType/queryQuestionTypeByTicketCategoryId?id=' + id)
}
export function addTicket(param) {
    return request.post('/ticket/addTicket', param)
}

//我的工单
export function queryTicketByUserID(userId) {
    return request.post('/ticket/queryTicketByUserID?userId=' + userId)
}
//删除工单
export function deleteTicket(ticketId) {
    return request.post('/ticket/deleteTicket?ticketId=' + ticketId)
}
//结束工单
export function endTicket(ticketId) {
    return request.post('/ticket/endTicket?ticketId=' + ticketId)
}

//常见问题及解决方案
export function queryQuestionAnswerByConditions(param) {
    return request.post('/questionAnswer/queryQuestionAnswerByConditions', param)
}
//反馈及意见
export function addFeedback(param) {
    return request.post('/feedback/addFeedback', param)
}